<div class="spinner-border spinner" role="status" [ngStyle]="{ color, fontSize }">
  <span class="visually-hidden">Loading...</span>
</div>
